import Step3 from 'pages/MobileTutorial/Steps/Step3/Step3'
export default Step3
